export default __webpack_public_path__ + "static/media/1750a751e28cb3550e8940e6ef232b19.svg";